import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from './store'
import {User, GroupType} from '../types/app-types'

type SelectorFunction = (state: any) => unknown

export const userSlice = createSlice({
  name: 'user',
  initialState: null,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state = action.payload
      return state
    }
  }
})

// selectors
export const selectUser = (state: RootState): User => state.user

export const selectEmail = (state: RootState) => {
  const {email} = selectUser(state)
  return email
}

export const selectDisplayName = (state: RootState) => {
  const user = selectUser(state)
  return user ? `${user.firstName} ${user.lastName}` : 'Resident'
}

export const selectGroups = (state: RootState): GroupType[] => {
  return state.user?.groups || []
}

export const selectHasGroup = (group: GroupType): SelectorFunction => {
  return (state: RootState): boolean => {
    const groups = selectGroups(state)
    return groups.indexOf(group) >= 0
  }
}

export const selectHasAllGroups = (groups: GroupType[]): SelectorFunction => {
  return (state: RootState): boolean => {
    const userGroups = selectGroups(state)
    for (const group of groups) {
      if (userGroups.indexOf(group) < 0) {
        return false
      }
    }
    return true
  }
}

export const selectHasAnyGroups = (groups: GroupType[]): SelectorFunction => {
  return (state: RootState): boolean => {
    const userGroups = selectGroups(state)
    for (const group of groups) {
      if (userGroups.indexOf(group) >= 0) {
        return true
      }
    }
    return false
  }
}

// actions
export const {setUser} = userSlice.actions

// reducer
export default userSlice.reducer
